// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3ATth","buttons":"SendReceipts_buttons__2H9wK","email":"SendReceipts_email__lL51n","bookApptTitle":"SendReceipts_bookApptTitle__R2MKv"};